import {AssessmentControlId, EngagementId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const controlOeForControl = typedQuery(
  ["tprm", "controlOeForControl", param<AssessmentControlId>("assessmentControlId")],
  async assessmentControlId => {
    return await api.tprm.controlOe.listForControl(assessmentControlId);
  },
);

export const controlOeTargets = typedQuery(
  ["tprm", "controlOeTargets", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.controlOe.listTargets(engagementId);
  },
);

export const controlOeUndependable = typedQuery(
  ["tprm", "controlOeUndependable", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.controlOe.listUndependable(engagementId);
  },
);

export const controlOeDependencies = typedQuery(
  ["tprm", "controlOeDependencies", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.controlOe.listDependencyEdges(engagementId);
  },
);
